import React from 'react';
import { Container } from 'react-bootstrap';
import { Routes, Route } from 'react-router-dom';
import EventStage from '../events/EventStage';
import RegistrationStage from '../registrations/RegistrationStage';
import ParticipantStage from '../participant/ParticipantStage';
import PaymentStage from '../payment/PaymentStage';
import VerifyStage from '../verify/VerifyStage';
import SuccessStage from '../success/SuccessStage';
import { BannerLayout } from './BannerLayout';
import * as routes from '../../routes'
import { IProgram } from '../../store/program/interfaces'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

// Banner image component to reduce duplication
const BannerImage = ({
                       link,
                       imgSrc,
                       altText
                     }: {
  link?: string,
  imgSrc?: string,
  altText: string
}) => {
  if (!imgSrc) return null;

  return link ? (
    <a href={link} target='_blank' rel='noopener noreferrer'>
      <img
        src={imgSrc}
        className='img-fluid mx-auto d-block'
        alt={altText}
      />
    </a>
  ) : (
    <img
      src={imgSrc}
      className='img-fluid mx-auto d-block'
      alt={altText}
    />
  );
};

// Banner components
const LeftBanner = ({program}: { program: IProgram }) => (
  <div className="banner banner-left">
    <BannerImage
      link={program.ad_left_link}
      imgSrc={program.ad_left_img}
      altText="Linkes Banner"
    />
  </div>
);

const RightBanner = ({program}: { program: IProgram }) => (
  <div className="banner banner-right">
    <BannerImage
      link={program.ad_right_link}
      imgSrc={program.ad_right_img}
      altText="Rechtes Banner"
    />
  </div>
);

const TopBanner = ({program}: { program: IProgram }) => (
  <div className="banner banner-top">
    <BannerImage
      link={program.ad_top_link}
      imgSrc={program.ad_top_img}
      altText="Oberes Banner"
    />
  </div>
);


export const ContentStructure = () => {

  const { data: program } = useSelector((state: RootState) => state.program)

  return (
    <BannerLayout
      leftBanner={<LeftBanner program={program} />}
      rightBanner={<RightBanner program={program} />}
      topBanner={<TopBanner program={program} />}
    >
      <Container id='main-content' className={"p-0"}>
        <Routes>
          <Route path='/' />
          <Route
            path={routes.EVENTS.path + '/:eventId?'}
            element={<EventStage />}
          />
          <Route
            path={routes.REGISTRATIONS.path + '/:eventId?'}
            element={<RegistrationStage />}
          />
          <Route
            path={routes.PARTICIPANT.path}
            element={<ParticipantStage />}
          />
          <Route path={routes.PAYMENT.path} element={<PaymentStage />} />
          <Route
            path={routes.VERIFY.path + '/:eventId?'}
            element={<VerifyStage />}
          />
          <Route path={routes.SUCCESS.path} element={<SuccessStage />} />
        </Routes>
      </Container>
    </BannerLayout>
  );
};
